<template>
  <g clip-path="url(#clip0_6202_11629)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.26667 0C1.01482 0 0 1.02335 0 2.28571L0 13.7143C0 14.9767 1.01482 16 2.26667 16L13.6 16C14.8518 16 15.8667 14.9767 15.8667 13.7143V11.4286C15.8667 10.7974 15.3593 10.2857 14.7333 10.2857C14.1074 10.2857 13.6 10.7974 13.6 11.4286V13.7143L2.26667 13.7143L2.26667 2.28571L10.0133 2.28571C10.6393 2.28571 11.1467 1.77404 11.1467 1.14286C11.1467 0.511675 10.6393 0 10.0133 0L2.26667 0ZM15.6681 4.23669C16.1106 3.79038 16.1106 3.06676 15.6681 2.62045C15.2255 2.17414 14.5079 2.17414 14.0653 2.62045L8.06667 8.66947L5.46805 6.04902C5.02546 5.60271 4.30787 5.60271 3.86528 6.04902C3.42268 6.49533 3.42268 7.21895 3.86528 7.66527L7.26528 11.0938C7.70787 11.5402 8.42546 11.5402 8.86806 11.0938L15.6681 4.23669Z"
      :fill="fill"
    />
  </g>
  <defs>
    <clipPath id="clip0_6202_11629">
      <rect :width="width" :height="height" :fill="rectFill" />
    </clipPath>
  </defs>
</template>
<script setup>
defineProps({
  fill: {
    type: String,
    default: "#868D9C",
  },
  rectFill: {
    type: String,
    default: "#fff",
  },
  width: {
    type: String,
    default: "16px",
  },
  height: {
    type: String,
    default: "16px",
  },
});
</script>
